module.exports = __webpack_public_path__ + "static/media/partner-portal-logo.98aa8405.png";